// @flow
import React, { Component, Fragment } from 'react'
import Button from '../../controls/SmallRoundedButton'
import ImagePreview from '../../ImagePreview'
import styled, { type StyledComponent } from 'styled-components'
import { grayColor } from '../../controls/colors'
import _ from 'lodash'
import type { Media } from '../../types'
import { translateFunc, translations } from '../../../shared/localize'

const borderWidth = 1

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${(props: Object) => props.width + 2 * borderWidth}px;
  height: ${(props: Object) => props.height + 2 * borderWidth}px;
  font-size: 14px;
  border-radius: 3px;
  color: black;
  text-align: center;
  border: ${borderWidth}px solid ${grayColor};
  position: relative;
  vertical-align: top;
`
const Message: StyledComponent<Object, any, any> = styled.div`
  text-align: center;
  margin: 2em 0;
`
const ShadowedButton: any = styled(Button)`
  box-shadow: 0 0 38px 0 rgba(0, 0, 0, 0.75);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
`
const CenteredButton: any = styled(Button)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
`
const Errors: StyledComponent<Object, any, any> = styled.div`
  position: absolute;
  bottom: 0;
  padding-bottom: 8px;
`
const Error: StyledComponent<Object, any, any> = styled.div`
  color: red;
  font-size: 12px;
  text-align: center;
`
const Notes: StyledComponent<Object, any, any> = styled.div`
  position: absolute;
  top: 0;
  padding-top: 8px;
`
const Note = styled.div`
  color: gray;
  font-size: 12px;
  text-align: center;
  background-color: white;
  padding: ${(props: Object) => (props.bright ? '1px 3px' : '0')};
`

type Props = {|
  media: ?(Media & { id?: ?number }),
  isLoading: boolean,
  height: ?number,
  width: ?number,
  errors: Array<string>,
  notes: Array<string>,
  onOpenFileDialog: Function
|}

const t = translateFunc(translations.single_media_loader)

export default class Preview extends Component<Props> {
  render() {
    const { media, onOpenFileDialog, isLoading, height, width, errors, notes } = this.props
    const calculatedHeight = height || 150
    const calculatedWidth = width || calculatedHeight * 1.3

    return media && _.isEmpty(errors) ? (
      <Wrapper height={calculatedHeight} width={calculatedWidth}>
        <Fragment>
          <ImagePreview
            imageSrc={media.src}
            width={calculatedWidth}
            height={calculatedHeight}
            size={{ width: media.width, height: media.height }}
            isCover
          />
          <ShadowedButton
            disabled={isLoading}
            onClick={() => onOpenFileDialog && onOpenFileDialog()}
          >
            {t(isLoading ? 'loading' : 'choose_another')}
          </ShadowedButton>
        </Fragment>
      </Wrapper>
    ) : (
      <Wrapper height={calculatedHeight} width={calculatedWidth}>
        {!_.isEmpty(notes) && (
          <Notes>
            {_.map(notes, (note, index: number) => (
              <Note key={index}>{note}</Note>
            ))}
          </Notes>
        )}
        {!_.isEmpty(errors) && (
          <Errors className="t-MediaErrorText">
            {_.map(errors, (error, index: number) => (
              <Error key={index}>{error}</Error>
            ))}
          </Errors>
        )}
        <Message>
          <CenteredButton
            disabled={isLoading}
            onClick={() => onOpenFileDialog && onOpenFileDialog()}
          >
            {t(isLoading ? 'loading' : 'choose')}
          </CenteredButton>
        </Message>
      </Wrapper>
    )
  }
}
